import React, { useState, useEffect, forwardRef } from 'react';
import './index.scss';
import {
    GetAllEmployeeDetails, VerifyUser, DeleteEmployee, EditEmployee, getCityList, getStateList, getCountriesList,
    GetAllEmployeeDetailsbyId, GenderMaster, getLogs
} from '../../utils/apicalls';
import MaterialTable from '@material-table/core';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import moment from 'moment';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import logo from '../../../assets/images/Sahyogi-logo.png';
import { useHistory } from 'react-router-dom';
import Confirm from '../../components/confirmModal/confirm';
import Loader from '../../components/loader';
import Switch from '@mui/material/Switch';
import Logout from '../logout';
import EditEmployeePopUp from '../../components/editemployeepopup'
import EmployeeDetailsPopUp from '../../components/employeedetailspopup';

const EmployeeList = () => {
    const history = useHistory();
    const [data, setData] = useState([]);
    const [employeeList, setEmployeeList] = useState([]);
    const [keys, setKeys] = useState([]);
    const [isShowLoader, setIsShowLoader] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [alertText, setAlertText] = useState('');
    const [isAddRightMenu, setisAddRightMenu] = useState(false);
    const [isPopUpDetails, setIsPopUpDetails] = useState(false);
    const [isLogsDetails, setIsLogsDetails] = useState(false);
    const [employeeLogs, setEmployeeLogs] = useState([]);
    const [dropdownList1, setDropdownList1] = useState('');
    const [dropdownList2, setDropdownList2] = useState('');
    const [dropdownList3, setDropdownList3] = useState('');
    const [dropdownList4, setDropdownList4] = useState('');

    useEffect(() => {
        getData();
        getCountries('');
        getGenderMaster('');
    }, []);

    useEffect(() => {
        getCities(employeeList.stateId);
    }, [employeeList.stateId]);

    const handleActive = (userId, isActive) => {
        const payload = {
            userId: userId,
            isActive: isActive
        }
        console.log(payload);
        if (payload) {
            VerifyUser((res) => {
                const { message, statusCode } = res;
                if (statusCode === 200) {
                    setIsShowLoader(false);
                    setShowConfirmModal(true);
                    setAlertText(message);
                    getData();
                }
            }, payload)
        }
    }

    const handleDelete = (userId) => {
        const payload = {
            userId: userId
        }
        if (payload) {
            DeleteEmployee((res) => {
                const { message, statusCode } = res;
                if (statusCode === 200) {
                    setIsShowLoader(false);
                    setShowConfirmModal(true);
                    setAlertText(message);
                    getData();
                } else {
                    setAlertText(message);
                }
            }, payload)
        }
    }

    const getGenderMaster = () => {
        GenderMaster((res) => {
            setDropdownList1(res);
        })
    }

    const getCountries = () => {
        getCountriesList((res) => {
            setDropdownList2(res);
            let value = res[0].id;
            if (value) {
                getStateList((res) => {
                    setDropdownList3(res);
                }, value)
            }
        });
    };

    const getCities = (val) => {
        if (val) {
            getCityList((res) => {
                setDropdownList4(res);
                // console.log(res);
            }, val)
        }
    }


    const handleClickPopUp = (userId) => {
        const payload = {
            userId: userId
        }
        if (payload) {
            GetAllEmployeeDetailsbyId((res) => {
                const { message, statusCode } = res;
                let val = res;
                setEmployeeList(val);
                setisAddRightMenu(true);
                if (statusCode === 200) {
                    setIsShowLoader(false);
                    setShowConfirmModal(true);
                    setAlertText(message);
                    getData();
                    setisAddRightMenu(true);
                } else {
                    setAlertText(message);
                }
            }, payload)
        }
    }


    const handlePopUpClick = (userId) => {
        const payload = {
            userId: userId
        }
        if (payload) {
            GetAllEmployeeDetailsbyId((res) => {
                const { message, statusCode } = res;
                let val = res;
                // console.log(val?.dateOfBirth
                //     ? moment(val?.dateOfBirth).format('DD/MM/YYYY')
                //     : '');
                setEmployeeList(val);
                setIsPopUpDetails(true);
                if (statusCode === 200) {
                    setIsShowLoader(false);
                    setShowConfirmModal(true);
                    setAlertText(message);
                    getData();
                    setIsPopUpDetails(true);
                } else {
                    setAlertText(message);
                }
            }, payload)
        }
    }

    const handleClickPopup = (userId) => {

        history.push(`/logs/${userId}`)
        window.location.reload();
    }

    function LoadOnce() {
        window.location.reload();
    }

    const getData = () => {
        GetAllEmployeeDetails((res) => {
            let values = res;
            values.forEach((val) => {
                if (val.createdDate) {
                    let momont = moment(val?.createdDate).format('DD/MM/YYYY');
                    val.createdDate = momont;
                }
            });
            // values.forEach((values, index) => { values.serial = index + 1; });
            const columns = [];
            let columnNames = [];

            columnNames = Object.keys(values[0]);
            for (const key in columnNames) {
                if (columnNames[key] === 'name') {
                    columns.push({ title: 'Operator Name', field: columnNames[key] });
                }
                // else if (columnNames[key] === 'genderName') {
                //     columns.push({ title: 'Gender', field: columnNames[key] });
                // }
                else if (columnNames[key] === 'isDeleted') {
                    columns.push({
                        title: 'Status', field: columnNames[key], render: row =>
                            <div>{row?.isDeleted === true ? (
                                <div>
                                    <p style={{ color: 'red' }}>Disabled</p>
                                </div>) :
                                <p style={{ color: 'green' }}>Enabled</p>
                            }

                            </div>
                    });
                }
                if (columnNames[key] === 'emailId') {
                    columns.push({ title: 'Operator Email', field: columnNames[key] });
                }
                else if (columnNames[key] === 'stateName') {
                    columns.push({ title: 'State', field: columnNames[key] });
                }
                if (columnNames[key] === 'cityName') {
                    columns.push({ title: 'City', field: columnNames[key] });
                }
                else if (columnNames[key] === 'mobileNumber') {
                    columns.push({ title: 'Mobile No.', field: columnNames[key] });
                }
                if (columnNames[key] === 'aadharNumber') {
                    columns.push({ title: 'Aadhar No.', field: columnNames[key] });
                }
                else if (columnNames[key] === 'pancardNumber') {
                    // columns.push({ title: 'Pancard No.', field: columnNames[key] });
                    columns.push({
                        title: 'Login', field: columnNames[key], render: row =>
                            <div style={{ cursor: 'pointer' }}>
                                <button className='logs' onClick={() => handleClickPopup(row.userId)}>
                                    Logs</button>
                            </div>
                    });
                }
                if (columnNames[key] === 'isVerified') {
                    columns.push({
                        title: 'Actions', field: columnNames[key], render: row =>
                            <div>{row?.isVerified === null ? (
                                <div>
                                    <i onClick={() => { handleActive(row.userId, row.isActive === false) }}
                                        style={{ cursor: 'pointer', color: 'green', padding: ' 0 5px' }} className='fa fa-check'></i>
                                    <i onClick={() => { handleActive(row.userId, row.isActive === true) }}
                                        style={{ cursor: 'pointer', color: 'red', padding: ' 0 5px' }} className='fa fa-times'></i>
                                </div>) :
                                <Switch checked={row.isDeleted === false}
                                    onClick={() => { handleDelete(row.userId, row.isDeleted === false) }}
                                    style={{ cursor: 'pointer', paddingLeft: '10px' }} />
                            }

                            </div>
                    });
                }
                if (columnNames[key] === 'isVerified') {
                    columns.push({
                        title: 'Edit', field: columnNames[key], render: row =>
                            <div style={{ cursor: 'pointer' }}>
                                <i onClick={() => handleClickPopUp(row.userId)} className='fa fa-pencil'
                                />
                            </div>
                    });
                }
                if (columnNames[key] === 'dateOfBirth') {
                    columns.push({
                        title: 'Details', field: columnNames[key], render: row =>
                            <div style={{ cursor: 'pointer' }}>
                                <i onClick={() => handlePopUpClick(row.userId)} className='fa fa-eye'
                                    style={{ cursor: 'pointer', color: '#1976d2', fontSize: '20px' }} />
                            </div>
                    });
                }
            }
            setKeys(columns);
            setData(values);
            // }
        });
    }



    const handleConfirm = (id, obj) => {
        if (obj) {
            console.log(obj);
            let payload = {
                userId: employeeList.userId,
                name: obj.text1,
                email: obj.text2,
                dateOfBirth: employeeList.dateOfBirth,
                // dateOfBirth: obj.text3,
                genderId: employeeList.genderId,
                countryId: 1,
                stateId: (obj.selectedDropdown3Value === "" ? employeeList.stateId : null),
                // cityId: employeeList.cityId,
                cityId: (obj.selectedDropdown4Value === "" ? employeeList.cityId : null),
                pincode: parseInt(obj.text4),
                address: obj.text5,
                aadharNumber: parseInt(obj.text6),
                mobile: parseInt(obj.text7),
                pancardNumber: obj.text8

            };

            console.log(payload);
            if (payload) {
                setIsShowLoader(true);
                EditEmployee((res) => {
                    const { message, statusCode } = res;
                    if (statusCode === 200) {
                        setIsShowLoader(false);
                        setShowConfirmModal(true);
                        setAlertText(message);
                        getData();
                    } else {
                        setIsShowLoader(false);
                        setShowConfirmModal(true);
                        setAlertText(message);
                    }
                }, payload);
            }
        } else {
            let payload = {
                userId: employeeList.userId,
                name: obj.text1,
                email: obj.text2,
                dateOfBirth: obj.text3,
                genderId: obj.selectedDropdown1Value,
                countryId: 1,
                stateId: obj.selectedDropdown3Value,
                cityId: obj.selectedDropdown4Value,
                pincode: parseInt(obj.text4),
                address: obj.text5,
                aadharNumber: parseInt(obj.text6),
                mobile: parseInt(obj.text7),
                pancardNumber: obj.text8
            };
            console.log(payload);
            if (payload) {
                setIsShowLoader(true);
                EditEmployee((res) => {
                    const { message, statusCode } = res;
                    if (statusCode === 200) {
                        setIsShowLoader(false);
                        setShowConfirmModal(true);
                        setAlertText(message);
                        getData();
                    } else {
                        setIsShowLoader(false);
                        setShowConfirmModal(true);
                        setAlertText(message);
                    }
                }, payload);
            }
        }

        setisAddRightMenu(false);
    };


    const tableIcons = {
        Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
        Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
        DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
        Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
        FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
        LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
        NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
        PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
        ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
        Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
        ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
        ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
    };


    const handleEmployeeList = () => {
        history.push('/employee-list');
        window.location.reload();
    }

    const handleBlockedList = () => {
        history.push('/blocked-list');
        window.location.reload();
    }

    const handleHome = () => {
        history.push('/home');
        window.location.reload();
    }

    const handleAddEmployeePage = () => {
        history.push('/add-employee');
        window.location.reload();
    }


    return (
        <div>
            <div className='employee-details1'>
                <div className='employee-sidebar'>
                    <div className='employee-header'>
                        <img src={logo} alt='' />
                        <p className='line'></p>
                    </div>
                    <div className='employee-links'>
                        <ul>
                            <li onClick={handleEmployeeList}><a>Employee Details</a></li>
                            <li onClick={handleBlockedList}><a>Blocked List</a></li>
                            <li onClick={handleHome}><a>Operators OTP's</a></li>
                            <li onClick={handleAddEmployeePage}><a>Add Employee</a></li>
                            <Logout />
                        </ul>
                    </div>
                </div>
                <div className='employee-data'>
                    <div className='employee-data-header'>
                        <h1>Employee List</h1>
                    </div>
                    <MaterialTable
                        icons={tableIcons}
                        data={data}
                        columns={keys}
                        options={{
                            filtering: false, sorting: true, showTitle: false, paging: true,
                            pageSize: 10,
                            emptyRowsWhenPaging: false,
                            pageSizeOptions: [5, 10, 20, 50, 100],
                        }}
                    />
                </div>
            </div>
            {showConfirmModal && (
                <Confirm buttonText={'OK'} isCancelRequired={false} confirmTitle={alertText}
                    onConfirm={() => { setShowConfirmModal(false) }} onCancel={() => { setShowConfirmModal(false) }} />
            )}
            {isAddRightMenu ? (
                <EditEmployeePopUp id=''
                    isDropdown1Required={true}
                    isDropdown2Required={true}
                    isDropdown3Required={true}
                    isDropdown4Required={true}
                    dropdown1Placeholder='Select Gender'
                    dropdown2Placeholder='Select Country'
                    dropdown3Placeholder='Select State'
                    dropdown4Placeholder='Select City'
                    updateSelectedDropDown1Value={employeeList}
                    updateSelectedDropDown2Value={employeeList?.countryName}
                    updateSelectedDropDown3Value={employeeList?.stateName}
                    updateSelectedDropDown4Value={employeeList?.cityName}
                    selectedDropdown1Value={employeeList?.genderId}
                    selectedDropdown2Value={employeeList?.countryId}
                    selectedDropdown3Value={employeeList?.stateId}
                    selectedDropdown4Value={employeeList?.cityId}
                    dropdown1List={dropdownList1}
                    dropdown2List={dropdownList2}
                    dropdown3List={dropdownList3}
                    dropdown4List={dropdownList4}
                    onConfirm={handleConfirm}
                    onCancel={() => { setisAddRightMenu(false); }}
                    commonTitle='Update Employee Details'
                    input1Placeholder='Full Name'
                    input2Placeholder='Email'
                    input3Placeholder='Date of Birth'
                    input4Placeholder='Pincode'
                    input5Placeholder='Address'
                    input6Placeholder='Aadhar Number'
                    input7Placeholder='Mobile Number'
                    input8Placeholder='Pancard Number'
                    input1Value={employeeList?.name}
                    input2Value={employeeList?.email}
                    input3Value={employeeList?.dateOfBirth
                        ? moment(employeeList?.dateOfBirth).format('DD/MM/YYYY')
                        : ''}
                    input4Value={employeeList?.pincode}
                    input5Value={employeeList?.address}
                    input6Value={employeeList?.aadharNumber}
                    input7Value={employeeList?.mobileNumber}
                    input8Value={employeeList?.pancardNumber}
                    isShowInput1={true}
                    isShowInput2={true}
                    isShowInput3={true}
                    isShowInput4={true}
                    isShowInput5={true}
                    isShowInput6={true}
                    isShowInput7={true}
                    isShowInput8={true}
                    // input4Placeholder='isPrimary'
                    btnText='Submit' />
            ) :
                null
            }
            {isPopUpDetails ? (
                <EmployeeDetailsPopUp id=''
                    userId={employeeList.userId}
                    isDropdown1Required={true}
                    isDropdown2Required={true}
                    isDropdown3Required={true}
                    isDropdown4Required={true}
                    onConfirm={handleConfirm}
                    onCancel={() => { setIsPopUpDetails(false); }}
                    commonTitle='Employee Details'
                    input1Placeholder='Full Name '
                    input2Placeholder='Email '
                    input3Placeholder='Date of Birth'
                    input4Placeholder='Pincode'
                    input5Placeholder='Address'
                    input6Placeholder='Aadhar Number'
                    input7Placeholder='Mobile Number'
                    input8Placeholder='Pancard Number'
                    input9Placeholder='Select Gender'
                    input10Placeholder='Select Country'
                    input11Placeholder='Select State'
                    input12Placeholder='Select City'
                    input1Value={employeeList?.name}
                    input2Value={employeeList?.email}
                    input3Value={employeeList?.dateOfBirth
                        ? moment(employeeList?.dateOfBirth).format('DD/MM/YYYY')
                        : ''}
                    input4Value={employeeList?.pincode}
                    input5Value={employeeList?.address}
                    input6Value={employeeList?.aadharNumber}
                    input7Value={employeeList?.mobileNumber}
                    input8Value={employeeList?.pancardNumber}
                    input9Value={employeeList?.genderName}
                    input10Value={employeeList?.countryName}
                    input11Value={employeeList?.stateName}
                    input12Value={employeeList?.cityName}
                    isShowInput1={true}
                    isShowInput2={true}
                    isShowInput3={true}
                    isShowInput4={true}
                    isShowInput5={true}
                    isShowInput6={true}
                    isShowInput7={true}
                    isShowInput8={true}
                    isShowInput9={true}
                    isShowInput10={true}
                    isShowInput11={true}
                    isShowInput12={true}
                    btnText='Submit'
                />
            ) :
                null
            }
            {isShowLoader ? <Loader /> : null}
        </div>
    )
}

export default EmployeeList;